import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import HeroSection from "./herosection/HeroSection";
import BoxContainer from "../../components/boxContainer/BoxContainer";
import Feature from "../../components/features/Feature";
import GetStarted from "../../components/getStarted/GetStarted";
import AstrologySolution from "../../components/AstrologySolution/AstrologySolution";
import ExploreWayBox from "../../components/exploreway/ExploreWayBox";
import Footer from "../../components/Footer/Footer";

const Home = () => {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <BoxContainer />
      <AstrologySolution />
      <Feature />
      <GetStarted />
      <ExploreWayBox />
      <Footer />
    </div>
  );
};

export default Home;
